"use strict";

function reallydoxhr() {
  let z = new XMLHttpRequest();
  z.open("get", "test-image.png", true);
  z.send();
}

function doxhr() {
  reallydoxhr();
}

window.doxhr = doxhr;



//////////////////
// WEBPACK FOOTER
// ./xhr_original.js
// module id = 0
// module chunks = 0